export const getAudieceFilteredData = (audienceFilters) => {
  let audienceFiltersArray = [];

  audienceFilters.map((filter) => {
    let filterParameterArray = [];
    filter.filterParameters.map((parameter) => {
     if(parameter&& parameter.properties){ 
      var parameterObj = {
        filterPropertyParameterId: parameter.properties.id,
        value: parameter.value,
      };
      filterParameterArray.push(parameterObj);
    }
    });

    if(filter.customParmId){

      filterParameterArray.push({
        filterPropertyParameterId: filter.customParmId,
        value : filter.customParamValue
      });

    }

    let obj = {
      id : filter.id ,
      filterPropertyId: filter.filterPropertyId,
      filterActionId: filter.filterActionId,
      filterValue: filter.filterValue,
      filterValueTypeId: filter.filterValueTypeId,
      logicalOperator: filter.logicalOperator,
      filterParameters: filter.filterPatameterToShow
        ? filterParameterArray
        : [],
    };



    audienceFiltersArray.push(obj);

  });


  return audienceFiltersArray;
};
